// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21SZX","type":"styles_type__3Otas","choices":"styles_choices__1Ix8H"};